export class UrlHelper {
  public toVoUrl = (url: string): string => {
    const origin = window.location.origin;
    return origin + '/vo/' + url;
  };
}
